import { gql } from '@apollo/client';

const getAisleBayTextMeQuery = () => {
  const aisleBayTextMe = `
    mutation AisleBayTextMe(
      $itemId: String!,
      $storeId: String!,
      $aisleBayText: String!,
      $phoneNumber: String!,
      $isSavingsSubscribed: Boolean
    ) {
      aisleBayTextMe(
        itemId: $itemId,
        storeId: $storeId,
        aisleBayText: $aisleBayText,
        phoneNumber: $phoneNumber,
        isSavingsSubscribed: $isSavingsSubscribed

      ) {
        result
      }
    }
 `;
  return gql(aisleBayTextMe);
};
export default getAisleBayTextMeQuery;
